<div class="modal-header">
  <h5 class="modal-title">{{ (isCreate ? 'Create Comment' : 'Update Comment') | messageTranslate }}</h5>
  <button type="button" ngbAutofocus class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  <app-upsert-ticket-comment #ticketComponent
                             [ticket]="ticket"
                             [comment]="comment"
                             [showErrors]="false"
                             [includeTicketUpdateFields]="includeTicketUpdateFields"
                             (progressEvent)="onUpsertCommentProgress($event)"/>
</div>
<div class="modal-footer">
  <app-button visual="primary"
              [label]="isCreate ? 'Add' : 'Update'"
              [loading]="updating"
              [disabled]="!ticketComponent.valid"
              (buttonClick)="ticketComponent.onSubmit()"/>
  <app-button visual="secondary" label="Cancel" buttonClass="ms-2" (buttonClick)="onCancel()"/>
</div>
